export default __webpack_public_path__ + "static/media/not-found-course.a937f43a.svg";